var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14282 5.14282V18.8571H22.2857V5.14282H5.14282ZM6.85711 6.85711H20.5714V17.1428H6.85711V6.85711Z",
    fill: "#0078E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1428V22.2857V24H1.71429H6.85714V22.2857H1.71429V17.1428H0Z",
    fill: "#0078E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7143 17.1428V22.2857H20.5714V24H25.7143H27.4286V22.2857V17.1428H25.7143Z",
    fill: "#0078E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 0V1.71429H25.7143V6.85714H27.4286V1.71429V0H25.7143H20.5714Z",
    fill: "#0078E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V1.71429V6.85714H1.71429V1.71429H6.85714V0H1.71429H0Z",
    fill: "#0078E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.a3010ff7a23a7f92214e7354ee566e75.svg";
export { ForwardRef as ReactComponent };